import { useContext } from "react";
import { LinkButton } from "../../common/buttons/LinkButton/LinkButton";
import { SessionContext } from "../../common/contexts/SessionContext";
import { getAddRoute, getIndexRoute } from "../../main/Routing";
import { customTypeTemplateConstants } from "../../api/CustomTypes/CustomTypeTemplates";
import { customFieldTemplateConstants } from "../../api/CustomFields/CustomFieldTemplates";
import { LucideIcon } from "../../common/icon/LucideIcon";
import { toUppercase } from "../../common/helperfunctions/stringFunctions";
import { documentationConstants } from "../../api/Misc";
import { customTypeConstants } from "../../api/CustomTypes/CustomTypes";
import { customFieldConstants } from "../../api/CustomFields/CustomFields";

export const TemplatesLandingPage = () => {
  const { route } = useContext(SessionContext);
  return (
    <div
      style={{
        padding: "20px",
        overflow: "auto",
        width: "100%",
        height: "100%",
        alignItems: "center",
      }}
    >
      <div
        style={{
          backgroundColor: "var(--white)",
          border: "1px solid var(--gray-300)",
          borderRadius: "8px",
          padding: "10px 20px",
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          width: "100%",
          minWidth: "650px",
          marginBottom: "20px",
        }}
      >
        <div className="flex align-center" style={{ justifyContent: "space-between" }}>
          <h2 style={{ margin: 0, padding: 0, whiteSpace: "nowrap" }}>
            <LucideIcon
              name={customTypeTemplateConstants.icon}
              color={"var(--primary)"}
              style={{ width: 20, height: 20 }}
            />{" "}
            {toUppercase(customTypeTemplateConstants.entityPlural)}
          </h2>
          <a
            className="btn btn-round btn-ghost-secondary"
            title="Learn more about custom types"
            href="https://logs-support.sciy.com/kb/article/350-custom-type/"
            target="_blank"
            rel="noreferrer"
          >
            <LucideIcon name={documentationConstants.icon} />
          </a>
        </div>
        <div style={{ textAlign: "justify" }}>
          Customized types extend standard metadata fields by additional custom fields & sections.
        </div>
        <hr style={{ padding: 0, margin: 0 }} />
        <div className="flex align-center gap-5">
          <LinkButton
            className="btn btn-primary"
            linkTo={route(getIndexRoute(customTypeTemplateConstants.frontendIndexRoute))}
          >
            <LucideIcon name="arrow-right" /> Browse {customTypeTemplateConstants.entityPlural}
          </LinkButton>
          <LinkButton
            className="btn btn-soft-secondary"
            linkTo={route(getAddRoute(customTypeConstants.frontendIndexRoute))}
          >
            ...or create a new {customTypeConstants.entitySingular} without a template
          </LinkButton>
        </div>
      </div>
      <div
        style={{
          backgroundColor: "var(--white)",
          border: "1px solid var(--gray-300)",
          borderRadius: "8px",
          padding: "10px 20px",
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          width: "100%",
          minWidth: "650px",
          marginBottom: "20px",
        }}
      >
        <div className="flex align-center" style={{ justifyContent: "space-between" }}>
          <h2 style={{ margin: 0, padding: 0, whiteSpace: "nowrap" }}>
            <LucideIcon
              name={customFieldTemplateConstants.icon}
              color={"var(--primary)"}
              style={{ width: 20, height: 20 }}
            />{" "}
            {toUppercase(customFieldTemplateConstants.entityPlural)}
          </h2>
          <a
            className="btn btn-round btn-ghost-secondary"
            title="Learn more about custom fields"
            href="https://logs-support.sciy.com/kb/article/351-custom-fields"
            target="_blank"
            rel="noreferrer"
          >
            <LucideIcon name={documentationConstants.icon} />
          </a>
        </div>
        <div style={{ textAlign: "justify" }}>
          Custom fields describe a customized input field for metadata and is defined by a specific data type and a set
          of additional options & rules. A custom field can be reused across multiple custom types.
        </div>
        <hr style={{ padding: 0, margin: 0 }} />
        <div className="flex align-center gap-5">
          <LinkButton
            className="btn btn-primary"
            linkTo={route(getIndexRoute(customFieldTemplateConstants.frontendIndexRoute))}
          >
            <LucideIcon name="arrow-right" /> Browse {customFieldTemplateConstants.entityPlural}
          </LinkButton>
          <LinkButton
            className="btn btn-soft-secondary"
            linkTo={route(getAddRoute(customFieldConstants.frontendIndexRoute))}
          >
            ...or create a new {customFieldConstants.entitySingular} without a template
          </LinkButton>
        </div>
      </div>
      {/* <div
        style={{
          backgroundColor: "var(--white)",
          border: "1px solid var(--gray-300)",
          borderRadius: "8px",
          padding: "10px 20px",
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          width: "100%",
          minWidth: "650px",
          marginBottom: "20px",
        }}
      >
        <h2 style={{ margin: 0, padding: 0, whiteSpace: "nowrap" }}>
          <LucideIcon
            name={customTypeTemplatePackageConstants.icon}
            color={"var(--primary)"}
            style={{ width: 20, height: 20 }}
          />{" "}
          {toUppercase(customTypeTemplatePackageConstants.entityPlural)}
        </h2>
        <div style={{ textAlign: "justify" }}>
          Custom type template packages are collections of custom types designed for specific use cases or domains.
          Browse available packages to quickly set up multiple related custom types at once.
        </div>
        <hr style={{ padding: 0, margin: 0 }} />
        <LinkButton
          className="btn btn-soft-primary"
          linkTo={route(getIndexRoute(customTypeTemplatePackageConstants.frontendIndexRoute))}
        >
          <LucideIcon name="arrow-right" /> Browse {customTypeTemplatePackageConstants.entityPlural}
        </LinkButton>
      </div> */}
    </div>
  );
};
